<template>
  <BaseWarning>
    <i18n path="warnings.transitions.unsuitableRiskLevel" tag="span">
      <template #instruction>
        {{ $t(`tactics.instructions.transitions.${data.transitionType}.${data.instruction}`) }}
      </template>
      <template #riskLevel>{{ riskLevel }}</template>
      <template #consequence>
        <a href="https://www.guidetofm.com/tactics/transition-play/" target="_blank">
          {{ consequence }}
        </a>
      </template>
    </i18n>
  </BaseWarning>
</template>

<script>
import BaseWarning from "./BaseWarning.vue";

export default {
  name: "WarningTransitionRisk",
  
  props: {
    data: Object
  },

  components: { BaseWarning },

  computed: {
    consequence: function () {
      return this.$t(`warnings.transitions.${this.data.instruction}Consequence`);
    },

    riskLevel: function() {
      const riskLevel = this.data.riskLevel > 0 ? "higher" : "lower";
      return this.$t(`warnings.transitions.riskLevel.${this.data.riskType}.${riskLevel}`);
    },
  },
};
</script>
